import type { AppProps } from 'next/app';
import Head from 'next/head';

import '@rockalingua/ui/styles';

import GoogleTagManagerNoScript from '@/components/analytics/gtm/GoogleTagManagerNoScript';
import GoogleTagManagerScript from '@/components/analytics/gtm/GoogleTagManagerScript';
import Plausible from '@/components/analytics/plausible/Plausible';

export default function App({ Component, pageProps }: AppProps) {
  const variant = pageProps.abVariant;

  return (
    <>
      <Head>
        <title>Rockalingua | Music based learning</title>
        <meta
          name="description"
          content="Videos, songs, games,.. Hundreds of interactive ready to use activities. Everything you need for a successful school year!"
        />
      </Head>
      <GoogleTagManagerScript variant={variant} />
      <GoogleTagManagerNoScript />
      <Plausible variant={variant} />
      <Component {...pageProps} />
    </>
  );
}
